/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var ChessKingIcon = createIcon({
  name: 'ChessKingIcon',
  height: 512,
  width: 448,
  svgPath: 'M416 476v24c0 6.627-5.373 12-12 12H44c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12zm-8.033-324H248v-48h50a6 6 0 0 0 6-6V62a6 6 0 0 0-6-6h-50V6a6 6 0 0 0-6-6h-36a6 6 0 0 0-6 6v50h-50a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h50v48H40.033c-27.574 0-46.879 27.244-37.738 53.259L87.582 448h272.836l85.287-242.741C454.846 179.244 435.541 152 407.967 152z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default ChessKingIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/chess-king-icon.js
// module id = 454
// module chunks = 0